(function($){
    $(function(){  //document.ready

        //DOM READY code here

      // Click more on Full Time detail pages
      
      $(".more-info-btn").click(function(){
        $(".more-info").toggle();
        $(".more-info-btn span").toggleClass("rotate-180");
      });
      

    });
  
  	$(window).on("load", function() {
      
      // Captions 	
      
          $(".rte img").each(function() {
          var imageCaption = $(this).attr("alt");
          if (imageCaption != '') {
              var imgWidth = $(this).width();
              var imgHeight = $(this).height();
              var position = $(this).position();
              var positionTop = (position.top + imgHeight - 26)
              $("<span class='img-caption'><em>" + imageCaption +
                  "</em></span>").css({
                  "position": "absolute",
                  "left": "0",
                  "width": imgWidth + "px"
              }).insertAfter(this);
          }
      });  
      
    });
  
    //Functions, Plugins, Etc.. Here
    //(does not wait for DOM READY STATE) 

})(jQuery);

